const swapPlayer = (context) => ({
    player: context.player === 'white' ? 'black' : 'white'
});
export { swapPlayer };
